import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'ceres-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FooterComponent {
    currentYear = new Date().getFullYear();
}
